<clx-row type="buttons">
    <clx-button
        [routerLink]="['/Administration/Upgrade/Schedule/' + batchUpgradeId]"
        test-id="sites.button.retryfailed"
        has-privileges="SiteBatchUpgrade"
        *ngIf="showCreateNewButton"
        i18n="@@batch-upgrade.details.retryfailed.button"
    >Retry batch upgrade</clx-button>
    <clx-button
        (onClick)="cancelUpgrade()"
        test-id="sites.button.cancel"
        has-privileges="SiteBatchUpgrade"
        *ngIf="!disableCancelButton"
        i18n="@@batch-upgrade.details.cancel.button"
    >Cancel batch upgrade</clx-button>
    <clx-button
        (onClick)="deleteUpgrade()"
        test-id="sites.button.cancel"
        has-privileges="SiteBatchUpgrade"
        i18n="@@batch-upgrade.details.delete.button"
    >Delete batch upgrade</clx-button>
</clx-row>
<plant-list
    id="assigned-plants-4"
    [remoteOperations]="remoteOperations"
    [source]="source"
    [showAssignColumn]="false"
    test-id="administration.grid.plants"
    route="/Administration/Plants/:plantid"
    [showUpgradeStatus]="true"
    [disabledColumns]="[
        'WebPictureFileId',
        'IsOnline',
        'RawAlarmStatus',
        'TaskStatus'
    ]"
    [isPlantAdministrationPage]="true"
></plant-list>
